<multiselect
    [(ngModel)]="searchFilter.query"
    (ngModelChange)="filterChange.emit($event)"
    [config]="searchFilter.multiselectConfig">
</multiselect>
